import { render } from "./NewViewChildPopup.vue?vue&type=template&id=03a65748&scoped=true"
import script from "./NewViewChildPopup.vue?vue&type=script&lang=js"
export * from "./NewViewChildPopup.vue?vue&type=script&lang=js"

import "./NewViewChildPopup.vue?vue&type=style&index=0&id=03a65748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a65748"]])

export default __exports__